<div class="flex flex-col space-y-3 h-full overflow-y-auto">
  <div class="pt-2">
    <button
      color="dark"
      class="flex items-center justify-between space-x-2 pl-4 p-[9.5px] w-full"
      [ngClass]="!expandSidebar ? 'mb-1' : 'mb-0'"
      routerLinkActive="active-sidebar-button"
    >
      <span
        *ngIf="expandSidebar"
        class="text-primary font-bold text-lg font-jura"
        >AsylumTix</span
      >
      <span
        class="material-icons-outlined text-[#BABCC0]"
        (click)="toggleSidebar()"
        >{{ expandSidebar ? 'first_page' : 'last_page' }}</span
      >
    </button>
  </div>
  <mat-divider class="pt-2"></mat-divider>
  <ng-container *ngIf="userRolesInCompany$ | async as roles">
    <div class="flex-1 flex flex-col">
      <button
        *ngIf="
          isAdmin(roles) ||
          isBoxOfficeUser(roles) ||
          isEventAdministrator(roles) ||
          isManager(roles)
        "
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['dashboard']"
        [matTooltip]="expandSidebar ? '' : 'Dashboard'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="chart-pie"></tix-icon>
        <span *ngIf="expandSidebar" class="company-sidebar-item-text"
          >Dashboard</span
        >
      </button>
      <button
        color="dark"
        *ngIf="
          isManager(roles) || isAdmin(roles) || isEventAdministrator(roles)
        "
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['venues']"
        [matTooltip]="expandSidebar ? '' : 'Venues'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="venue"></tix-icon>
        <div
          *ngIf="expandSidebar"
          class="flex-1 flex items-center justify-between"
        >
          <span class="company-sidebar-item-text">Venues</span>
          <span
            class="inline-flex items-center py-0.5 px-2 rounded-full text-xs font-medium bg-danger text-white"
            >{{ (venuesAggregate$ | async) ?? 0 }}</span
          >
        </div>
      </button>
      <button
        color="dark"
        *ngIf="
          isManager(roles) || isAdmin(roles) || isEventAdministrator(roles)
        "
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['events']"
        [matTooltip]="expandSidebar ? '' : 'Events'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="event"></tix-icon>
        <div
          *ngIf="expandSidebar"
          class="flex-1 flex items-center justify-between"
        >
          <span class="company-sidebar-item-text">Events</span>
          <span
            class="inline-flex items-center py-0.5 px-2 rounded-full text-xs font-medium bg-danger text-white"
            >{{ eventsAggregate$ | async }}</span
          >
        </div>
      </button>
      <button
        *ngIf="isAdmin(roles)"
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['staff']"
        [matTooltip]="expandSidebar ? '' : 'Staff'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="staff"></tix-icon>
        <div
          *ngIf="expandSidebar"
          class="flex-1 flex items-center justify-between"
        >
          <span class="company-sidebar-item-text">Staff</span>
          <span
            class="inline-flex items-center py-0.5 px-2 rounded-full text-xs font-medium bg-danger text-white peer-hover:text-primary"
            >{{ (contactsAggregate$ | async) ?? 0 }}</span
          >
        </div>
      </button>
      <button
        *ngIf="isAdmin(roles) || isEventAdministrator(roles)"
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['customers']"
        [matTooltip]="expandSidebar ? '' : 'Customers'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="customers"></tix-icon>
        <div
          *ngIf="expandSidebar"
          class="flex-1 flex items-center justify-between"
        >
          <span class="company-sidebar-item-text">Customers</span>
          <span
            class="inline-flex items-center py-0.5 px-2 rounded-full text-xs font-medium bg-danger text-white"
            >{{ (customersAggregate$ | async) ?? 0 }}</span
          >
        </div>
      </button>
      <button
        *ngIf="isAdmin(roles)"
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['discounts']"
        [matTooltip]="expandSidebar ? '' : 'Discounts'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="currency-dollar"></tix-icon>
        <span *ngIf="expandSidebar" class="company-sidebar-item-text"
          >Discounts</span
        >
      </button>

      <button
        *ngIf="isAdmin(roles) || isManager(roles) || isBoxOfficeUser(roles)"
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLinkActiveOptions]="{ exact: false }"
        [routerLink]="['Add-Ons']"
        [matTooltip]="expandSidebar ? '' : 'Add-Ons'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <span class="material-icons-outlined tix-icon">extension</span>
        <span *ngIf="expandSidebar" class="company-sidebar-item-text"
          >Addons</span
        >
      </button>
      <!-- <button
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['finance']"
        [matTooltip]="expandSidebar ? '' : 'Finance'"
        [matTooltipPosition]="matTooltipPosition"
      >
        <span class="material-icons tix-icon">query_stats</span>
        <span *ngIf="expandSidebar" class="company-sidebar-item-text"
          >Finance</span
        >
      </button> -->
      <button
        *ngIf="
          isAdmin(roles) || isManager(roles) || isEventAdministrator(roles)
        "
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['reports']"
        [matTooltip]="expandSidebar ? '' : 'Reports'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon svgIcon="document-report"></tix-icon>
        <span *ngIf="expandSidebar" class="company-sidebar-item-text"
          >Reports</span
        >
      </button>

      <button
        *ngIf="isAdmin(roles) || isManager(roles)"
        color="dark"
        class="sidebar-item-button group flex items-center space-x-2 pl-4 p-3 cursor-pointer hover:bg-matprimary-50 hover:text-primary group:peer"
        routerLinkActive="active-sidebar-button"
        [routerLink]="['communications']"
        [matTooltip]="expandSidebar ? '' : 'communications'"
        [matTooltipPosition]="matTooltipPosition"
        (click)="onNavigationClick()"
      >
        <tix-icon class="peer-hover:text-primary" svgIcon="chat-alt"></tix-icon>
        <span *ngIf="expandSidebar" class="company-sidebar-item-text"
          >Communications</span
        >
      </button>
    </div>
  </ng-container>

  <!-- Release Switcher Button -->
  <div *ngIf="expandSidebar" class="mt-auto p-4">
    <button
      type="button"
      class="w-full flex items-center justify-center space-x-2 p-2 text-xs text-gray-500 hover:text-primary border border-gray-300 rounded-md hover:border-primary transition-colors"
      (click)="switchToStableRelease()"
      title="Switch to Stable Release"
    >
      <span class="material-icons-outlined text-sm">swap_horiz</span>
      <span>Switch to the old experience</span>
    </button>
  </div>
</div>
